<div class="course-page">
  <!-- Header with breadcrumb and progress -->
  <ut-academy-header
    [title]="headerTitle"
    [showProgress]="isPartOfLearningTrack"
    [currentProgress]="trackCoursesCompleted"
    [totalItems]="trackCoursesTotal"
    (backClick)="onBackToTracks()">
  </ut-academy-header>

  @if (isLockedByOrder) {
    <ut-academy-course-locked [learningTrackName]="courseTrack.learning_track_name"></ut-academy-course-locked>
  } @else {
  <!-- Main Content Area: Lesson + Sidebar -->
  <div class="course-layout">
    <!-- Left: Lesson Display + Navigation -->
    <section class="course-main" aria-label="Lesson content">
      <div class="lesson-container">
        <ut-lesson-display
          [lesson]="currentLesson">
        </ut-lesson-display>

        <ut-lesson-navigation
          [hasPrevious]="hasPreviousLesson"
          [hasNext]="hasNextLesson"
          [isFirstLesson]="isFirstLesson"
          [isLastLesson]="isLastLesson"
          [hasQuiz]="hasQuiz"
          [isQuizAvailable]="isQuizAvailable"
          (previousClick)="onPreviousLesson()"
          (continueClick)="onContinueLesson()"
          (quizClick)="onNavigateToQuiz()"
          (finishClick)="onBackToTracks()">
        </ut-lesson-navigation>
      </div>
    </section>

    <!-- Right: Course Content Sidebar -->
    <aside class="course-sidebar" aria-label="Course information">
      <ut-course-content-sidebar
        [courseTrack]="courseTrack"
        [currentLessonId]="currentLesson?.id"
        [showSignUpConfirmation]="showSignUpConfirmation"
        (lessonClick)="onLessonSelect($event)"
        (quizClick)="onNavigateToQuiz()"
        (cycleSignUp)="onCycleSignUp()"
        (cycleSignUpConfirm)="onCycleSignUpConfirm()">
      </ut-course-content-sidebar>
    </aside>
  </div>
  }
</div>
